import { SchemaField } from '../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

export class ConferenceParticipantSchema extends SerializableObjectSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly callSid = 'callSid';

  public static readonly label = 'label';

  public static readonly coaching = 'coaching';

  public static readonly muted = 'muted';

  public static readonly hold = 'hold';

  public static readonly status = 'status';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly callSid = undefined;

    public static readonly label = undefined;

    public static readonly coaching = undefined;

    public static readonly muted = undefined;

    public static readonly hold = undefined;

    public static readonly status = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[ConferenceParticipantSchema.callSid] = SchemaField.string(
      ConferenceParticipantSchema.Defaults.callSid,
    ).required();
    parameters[ConferenceParticipantSchema.label] = SchemaField.string(
      ConferenceParticipantSchema.Defaults.label,
    ).optional();
    parameters[ConferenceParticipantSchema.coaching] = SchemaField.boolean(
      ConferenceParticipantSchema.Defaults.coaching,
    ).optional();
    parameters[ConferenceParticipantSchema.muted] = SchemaField.boolean(
      ConferenceParticipantSchema.Defaults.muted,
    ).optional();
    parameters[ConferenceParticipantSchema.hold] = SchemaField.boolean(
      ConferenceParticipantSchema.Defaults.hold,
    ).optional();
    parameters[ConferenceParticipantSchema.status] = SchemaField.string(
      ConferenceParticipantSchema.Defaults.status,
    ).optional();
    /* eslint-enable */

    return parameters;
  }
}
